import {cs}                from "@Common/react/chain-services";
import {Static2}           from "@Common/react/static-2";
import {UseState}          from "@Common/react/use-state";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {keepOnly}          from "@Common/utils/objects";

export const LineItemsLogic = ({templateOptions, item, method, next: rootNext}) => cs(
    ["qrEnabled", ({}, next) => Static2({getInitValue: () => false, next})],
    ["lineItems", ({}, next) => next(getLineItemsFromMethod({templateOptions, method}))],
    ["state", ({lineItems, qrEnabled}, next) => UseState({
        getInitValue: () => chain(
            item?.selections?.options?.filter((o) => o.group === "lineItem").map((o) => (
                o.dev_key !== "qr_code" && {
                    dev_key: o.dev_key,
                    ...(o?.subOptionDevKey ? {subOptionDevKey: o.subOptionDevKey} : {})
                }
            )) ??
            lineItems.map((lineItem) => lineItem.isRequired && lineItem.dev_key !== "qr_code" && {
                dev_key: lineItem.dev_key,
                ...(lineItem.showSubOptions ? {subOptionDevKey: lineItem.subOptions[0].dev_key} : {})
            }),
            (_) => _.filter((o) => o),
            (_) => ({
                saved  : _,
                current: _,
            }),
            (_) => {
                let qrCode = item?.selections?.options?.filter((o) => o.group === "lineItem").find((l) => l.dev_key === "qr_code")
                let qrCodeValid = qrCode && lineItems.find((l) => l.dev_key === "qr_code")?.subOptions.find((subOption) => subOption.dev_key === qrCode.subOptionDevKey);
                const qrLineItem = lineItems.find((l) => l.dev_key === "qr_code");
                if( qrLineItem && item?.tracking?.redirectType ) {
                    const qrSubOption = qrLineItem.subOptions.find((subOption) => subOption.dev_key === item?.tracking?.redirectType);
                    if(!qrCode && qrSubOption) {
                        qrEnabled.set(true);
                        qrCode = {
                            dev_key: "qr_code",
                            subOptionDevKey: item?.tracking?.redirectType,
                            redirectType: item?.tracking?.redirectType,
                            redirectUrl: item?.tracking?.redirectUrl,
                        };
                    } else if(!qrCode && !qrSubOption) {
                        qrEnabled.set(true);
                        qrCode = {
                            dev_key: "qr_code",
                            subOptionDevKey: qrLineItem.subOptions[0].dev_key,
                            redirectType: qrLineItem.subOptions[0].dev_key,
                        };
                        if(qrCode.subOptionDevKey === 'url') {
                            qrCode.redirectUrl = item?.tracking?.redirectUrl;
                        } else {
                            delete item?.tracking?.redirectUrl;
                        }
                    } else if(qrCode && qrSubOption) {
                        qrEnabled.set(true);
                        qrCode.subOptionDevKey = item?.tracking?.redirectType;
                        qrCode.redirectType = item?.tracking?.redirectType;
                        if(qrCode.subOptionDevKey === 'url') {
                            qrCode.redirectUrl = item?.tracking?.redirectUrl;
                        } else {
                            delete item?.tracking?.redirectUrl;
                        }
                        qrCode = keepOnly(qrCode, ["dev_key", "subOptionDevKey", "redirectType", "redirectUrl"]);
                    } else if( qrCode && (qrLineItem?.isRequired || !qrCodeValid) ) {
                        qrEnabled.set(true);
                        qrCode.subOptionDevKey = qrLineItem.subOptions[0].dev_key;
                        qrCode.redirectType = qrLineItem.subOptions[0].dev_key;
                        if(qrCode.redirectType === 'url') {
                            qrCode.redirectUrl = item?.tracking?.redirectUrl;
                        } else {
                            delete qrCode.redirectUrl;
                        }
                        qrCode = keepOnly(qrCode, ["dev_key", "subOptionDevKey", "redirectType", "redirectUrl"]);
                    } else if(qrCode) {
                        qrEnabled.set(true);
                        qrCode.redirectType = qrCode.subOptionDevKey;
                        if(qrCode.redirectType === 'url') {
                            qrCode.redirectUrl = item?.tracking?.redirectUrl;
                        } else {
                            delete qrCode.redirectUrl;
                        }
                        qrCode = keepOnly(qrCode, ["dev_key", "subOptionDevKey", "redirectType", "redirectUrl"]);
                    }
                    return {
                        ..._,
                        current: [
                            ..._.current,
                            qrCode,
                        ],
                    };
                } else if( qrLineItem?.isRequired ) {
                    qrEnabled.set(true);
                    if(item?.tracking?.redirectUrl) {
                        const qrSubOption = qrLineItem.subOptions.find((subOption) => subOption.dev_key === 'url');
                        if(qrSubOption) {
                            qrCode = {
                                dev_key: "qr_code",
                                subOptionDevKey: 'url',
                                redirectType: 'url',
                                redirectUrl: item?.tracking?.redirectUrl,
                            };
                        } else {
                            qrCode = {
                                dev_key: "qr_code",
                                subOptionDevKey: qrLineItem.subOptions[0].dev_key,
                                redirectType: qrLineItem.subOptions[0].dev_key,
                            };
                        }
                    } else {
                        qrCode = {
                            dev_key: "qr_code",
                            subOptionDevKey: qrLineItem.subOptions[0].dev_key,
                            redirectType: qrLineItem.subOptions[0].dev_key,
                        };
                    }
                    return {
                        ..._,
                        current: [
                            ..._.current,
                            qrCode,
                        ],
                    };
                }
                return _;
            },
        ),
        next,
    })],
    ["selectedLineItems", ({lineItems, state}, next) => next(
        lineItems
            .filter((lineItem) => lineItem.isRequired || !!state.value.current.find((l) => lineItem.dev_key === l.dev_key))
    )],
    ({state, lineItems, selectedLineItems, qrEnabled}) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections", "options"], (_) => _?.filter((o) => o.group !== "lineItem")),
        qrEnabled,
        selectedLineItems,
        lineItems: lineItems.filter((lineItem) => lineItem.isUi),
        state,
    }),
);

export const getLineItemsFromMethod = ({templateOptions, method}) => (
    templateOptions.options.filter((o) =>
        o.group === "lineItem" &&
        ~o.distributionFilter.indexOf(method) &&
        (o.isUi || o.isRequired) &&
        true
    )
)
